import React from 'react';
import classnames from 'classnames';

const Input = ({
    label = '',
    placeholder = null,
    id = 'input',
    name = null,
    validators = [],
    errorMessage = '',
    value = '',
    type = 'text',
    disabled = false,
    required = false,
    autoComplete = undefined,
    className = '',
    inputClassName = null,
    hideLabel = false,
    flex = false,
    collapse = false,
    inline = false,
    showRequired = false,

    error = false,
    touched = false,

    children = null,

    onChange = () => {},
    onBlur = () => {},
    onFocus = () => {},
    onKeyUp = () => {}
}) => {
    let labelCss = classnames({
        'required': required || showRequired,
        'hidden': hideLabel,
        'flex': flex
    });

    return (
        <div className={className}>
            {label  && <label htmlFor={id} className={labelCss}>{label}</label>}
            <div className="input-box">
                <input
                    className={classnames(inputClassName, {
                        'mb-0': collapse,
                        'error': error && touched,
                        'input-inline': inline
                    })}
                    value={value}
                    type={type}
                    name={name || id}
                    id={id}
                    required={required}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onChange={onChange}
                    onKeyUp={onKeyUp}
                    placeholder={placeholder}
                    disabled={disabled}
                    autoComplete={autoComplete}
                />
                {error && touched &&
                    <div className="errors-list" style={{opacity: 1}}>
                        <span>{error}</span>
                    </div>
                }
                {children}
            </div>
        </div>
    );
}

export default Input;
